module.exports = __webpack_public_path__ + "static/media/21ECLAC43.0839afe7.jpg";